// Foresight checklist (#831): step 6, wildcard_test.v1 — wild cards and their stress tests.
// Merged into the `foresight` namespace next to foresightStrings.js.

export const foresightWildcardFi = {
  wildcard: {
    title: 'Villi kortti',
    lead: 'Villi kortti on äkillinen, yllättävä tapahtuma, joka muuttaisi tilannetta merkittävästi. Sillä ei rakenneta uutta skenaariota, vaan testataan, mihin oletuksiin toimintapolku nojaa: jos polun keskeiset ratkaisut kestävät yllätyksen, suunnitelma on siltä osin vahva; jos koko polku muuttuu, kortti on paljastanut oletuksen. Pyydä tekoälyltä kortteja tai kirjoita omasi. Kortteja voi testata niin monta kuin haluat; yksi kirjattu päätös riittää vaiheen valmistumiseen.',
    generate: 'Ehdota villejä kortteja',
    generateMore: 'Ehdota lisää kortteja',
    addOwn: 'Kirjoita oma kortti',
    empty: 'Kortteja ei ole vielä. Tekoälyn ehdotukset eivät toista valitsemiasi muutosvoimia; oma korttisi voi nousta omasta toimintaympäristöstäsi.',
    done: 'Päätös kirjattu ({{n}})',
    fromAi: 'Tekoälyn ehdotus',
    own: 'Oma kortti',
    sharedToBank: 'Jaetaan korttipankkiin',
    cardTitle: 'Otsikko',
    cardTitlePlaceholder: 'Mitä tapahtui? Esim. Keskeinen kumppani lopettaa toimintansa',
    cardDescription: 'Kuvaus',
    cardDescriptionPlaceholder: 'Mitä tapahtuu, kuinka nopeasti ja mitä se muuttaa heti?',
    shareToBank: 'Jaa kortti myöhemmin koottavaan villien korttien pankkiin',
    test: 'Stressitestaa polku tällä kortilla',
    testAgain: 'Testaa uudelleen',
    testAgainNote: 'Uusi testi korvaa tuloksen, seurattavat signaalit ja päätöksen. Polkuun jo tehdyt muutokset säilyvät.',
    confirmTestAgain: 'Testataanko uudelleen? Nykyinen tulos, seurattavat signaalit ja päätös korvautuvat. Polkuun jo tehdyt muutokset säilyvät.',
    stale: 'Korttia on muokattu testin jälkeen. Testaa uudelleen, jotta tulos vastaa korttia.',
    verdicts: {
      holds: 'Polku kestää',
      adjust: 'Polkua pitää säätää',
      breaks: 'Polku murtuu',
    },
    assumptionsTitle: 'Paljastuneet oletukset',
    adjustmentsTitle: 'Ehdotetut muutokset polkuun',
    adjustmentsLead: 'Hyväksytty muutos kirjataan toimintapolkuun heti. Voit muokata kohtaa myöhemmin backcasting-vaiheessa.',
    noAdjustments: 'Tekoäly ei ehdottanut muutoksia.',
    revise: 'Muuttaa kohtaa',
    add: 'Lisää kohdan',
    acceptToPath: 'Hyväksy polkuun',
    editAndAccept: 'Muokkaa ja hyväksy',
    editAdjustment: 'Muokkaa ehdotusta ennen kuin se kirjataan polkuun',
    checkPath: 'Tarkista backcasting-vaiheessa, että hyväksytyt muutokset istuvat polkuun ja vaiheisiin.',
    openPath: 'Avaa polku',
    showResult: 'Näytä testin tulos',
    hideResult: 'Pienennä',
    finished: 'Ennakointi on valmis: vähintään yhdellä kortilla on kirjattu päätös. Päätetyt kortit näkyvät tiivistettyinä; voit avata ne tai testata lisää kortteja.',
    applied: 'Lisätty polkuun',
    rejected: 'Hylätty',
    signalsTitle: 'Seurattavat signaalit',
    checkpoint: 'Tarkistus {{stage}} · {{year}}',
    indicator: 'Mistä sen huomaa',
    watches: 'Oletus, jota se vartioi',
    decisionTitle: 'Päätös',
    decisions: {
      accept_path: 'Polku hyväksytään sellaisenaan',
      path_adjusted: 'Polkua muutettiin',
    },
    decisionLead: 'Kirjaa, miksi polku kestää tämän kortin sellaisenaan tai miksi ja miten sitä muutettiin. Perustelu tallentuu raporttiin.',
    decisionReason: 'Perustelu (pakollinen)',
    saveDecision: 'Kirjaa päätös',
    changeDecision: 'Muuta päätöstä',
    errors: {
      item_gone: 'Kohta, jota muutos koskee, on jo poistettu polulta.',
      already_applied: 'Muutos on jo kirjattu polkuun.',
      missing_reason: 'Kirjaa päätökselle perustelu.',
    },
    report: {
      intro: 'Villit kortit, joilla toimintapolkua testattiin: arvio, mitä kortti olisi tehnyt polulle, ja käyttäjän päätös perusteluineen.',
      changedItems: 'Muutokset polkuun',
      revealedTitle: 'Villin kortin "{{title}}" paljastamat oletukset',
      signalsTitle: 'Seurattavat signaalit ja tarkistuspisteet',
    },
  },
};

export const foresightWildcardEn = {
  wildcard: {
    title: 'Wild card',
    lead: 'A wild card is a sudden, surprising event that would change the situation significantly. It is not used to build a new scenario but to test which assumptions the path rests on: if the path\'s key solutions survive the surprise, the plan is robust in that respect; if the whole path changes, the card has revealed an assumption. Ask the AI for cards or write your own. Test as many cards as you like; one recorded decision is enough to complete the step.',
    generate: 'Suggest wild cards',
    generateMore: 'Suggest more cards',
    addOwn: 'Write your own card',
    empty: 'No cards yet. The AI\'s suggestions don\'t repeat the change drivers you chose; your own card can come from your own context.',
    done: 'Decision recorded ({{n}})',
    fromAi: 'AI suggestion',
    own: 'Own card',
    sharedToBank: 'Shared to the card bank',
    cardTitle: 'Title',
    cardTitlePlaceholder: 'What happened? E.g. A key partner shuts down',
    cardDescription: 'Description',
    cardDescriptionPlaceholder: 'What happens, how fast, and what does it change at once?',
    shareToBank: 'Share the card with the wild-card bank to be collected later',
    test: 'Stress-test the path with this card',
    testAgain: 'Test again',
    testAgainNote: 'A new test replaces the result, the watch signals and the decision. Changes already made to the path stay.',
    confirmTestAgain: 'Test again? The current result, watch signals and decision will be replaced. Changes already made to the path stay.',
    stale: 'The card was edited after the test. Test again so the result matches the card.',
    verdicts: {
      holds: 'The path holds',
      adjust: 'The path needs adjusting',
      breaks: 'The path breaks',
    },
    assumptionsTitle: 'Revealed assumptions',
    adjustmentsTitle: 'Suggested changes to the path',
    adjustmentsLead: 'An accepted change is written to the path at once. You can edit the item later in the backcasting step.',
    noAdjustments: 'The AI suggested no changes.',
    revise: 'Revises an item',
    add: 'Adds an item',
    acceptToPath: 'Accept onto the path',
    editAndAccept: 'Edit and accept',
    editAdjustment: 'Edit the suggestion before it is written to the path',
    checkPath: 'Check in the backcasting step that the accepted changes fit the path and its stages.',
    openPath: 'Open the path',
    showResult: 'Show the test result',
    hideResult: 'Collapse',
    finished: 'The foresight is complete: at least one card has a recorded decision. Decided cards are shown folded; you can open them or test more cards.',
    applied: 'Added to the path',
    rejected: 'Rejected',
    signalsTitle: 'Signals to watch',
    checkpoint: 'Check at {{stage}} · {{year}}',
    indicator: 'How it shows',
    watches: 'Assumption it watches',
    decisionTitle: 'Decision',
    decisions: {
      accept_path: 'The path is accepted as it is',
      path_adjusted: 'The path was changed',
    },
    decisionLead: 'Write down why the path holds against this card as it is, or why and how it was changed. The reasoning goes into the report.',
    decisionReason: 'Reasoning (required)',
    saveDecision: 'Record the decision',
    changeDecision: 'Change the decision',
    errors: {
      item_gone: 'The item this change applies to has already been removed from the path.',
      already_applied: 'The change is already on the path.',
      missing_reason: 'Give a reason for the decision.',
    },
    report: {
      intro: 'The wild cards the path was tested with: what each card would have done to the path, and the user\'s decision with its reasons.',
      changedItems: 'Changes to the path',
      revealedTitle: 'Assumptions revealed by the wild card "{{title}}"',
      signalsTitle: 'Signals to watch and checkpoints',
    },
  },
};

export const foresightWildcardSv = {
  wildcard: {
    title: 'Wild card',
    lead: 'Ett wild card är en plötslig, överraskande händelse som skulle förändra situationen avsevärt. Det används inte för att bygga ett nytt scenario utan för att testa vilka antaganden handlingsvägen vilar på: om vägens centrala lösningar klarar överraskningen är planen robust i det avseendet; om hela vägen förändras har kortet avslöjat ett antagande. Be AI:n om kort eller skriv ett eget. Testa så många kort du vill; ett antecknat beslut räcker för att slutföra steget.',
    generate: 'Föreslå wild cards',
    generateMore: 'Föreslå fler kort',
    addOwn: 'Skriv ett eget kort',
    empty: 'Inga kort ännu. AI:ns förslag upprepar inte de förändringskrafter du valt; ditt eget kort kan komma från din egen omvärld.',
    done: 'Beslut dokumenterat ({{n}})',
    fromAi: 'AI:ns förslag',
    own: 'Eget kort',
    sharedToBank: 'Delas till kortbanken',
    cardTitle: 'Rubrik',
    cardTitlePlaceholder: 'Vad hände? T.ex. En central partner upphör med sin verksamhet',
    cardDescription: 'Beskrivning',
    cardDescriptionPlaceholder: 'Vad händer, hur snabbt och vad förändras genast?',
    shareToBank: 'Dela kortet till den wild card-bank som samlas senare',
    test: 'Stresstesta vägen med det här kortet',
    testAgain: 'Testa igen',
    testAgainNote: 'Ett nytt test ersätter resultatet, signalerna att följa och beslutet. Ändringar som redan gjorts i vägen finns kvar.',
    confirmTestAgain: 'Testa igen? Nuvarande resultat, signaler att följa och beslut ersätts. Ändringar som redan gjorts i vägen finns kvar.',
    stale: 'Kortet har redigerats efter testet. Testa igen så att resultatet motsvarar kortet.',
    verdicts: {
      holds: 'Vägen håller',
      adjust: 'Vägen behöver justeras',
      breaks: 'Vägen brister',
    },
    assumptionsTitle: 'Avslöjade antaganden',
    adjustmentsTitle: 'Föreslagna ändringar i vägen',
    adjustmentsLead: 'En godkänd ändring förs in i handlingsvägen genast. Du kan redigera punkten senare i backcasting-steget.',
    noAdjustments: 'AI:n föreslog inga ändringar.',
    revise: 'Ändrar en punkt',
    add: 'Lägger till en punkt',
    acceptToPath: 'Godkänn till vägen',
    editAndAccept: 'Redigera och godkänn',
    editAdjustment: 'Redigera förslaget innan det förs in i vägen',
    checkPath: 'Kontrollera i backcasting-steget att de godkända ändringarna passar in i vägen och dess steg.',
    openPath: 'Öppna vägen',
    showResult: 'Visa testresultatet',
    hideResult: 'Fäll ihop',
    finished: 'Framsynen är klar: minst ett kort har ett antecknat beslut. Kort med beslut visas hopfällda; du kan öppna dem eller testa fler kort.',
    applied: 'Tillagd i vägen',
    rejected: 'Avvisad',
    signalsTitle: 'Signaler att bevaka',
    checkpoint: 'Kontroll {{stage}} · {{year}}',
    indicator: 'Hur det syns',
    watches: 'Antagande som den bevakar',
    decisionTitle: 'Beslut',
    decisions: {
      accept_path: 'Vägen godkänns som den är',
      path_adjusted: 'Vägen ändrades',
    },
    decisionLead: 'Skriv ner varför vägen håller mot detta kort som den är, eller varför och hur den ändrades. Motiveringen sparas i rapporten.',
    decisionReason: 'Motivering (obligatorisk)',
    saveDecision: 'Dokumentera beslutet',
    changeDecision: 'Ändra beslutet',
    errors: {
      item_gone: 'Punkten som ändringen gäller har redan tagits bort från vägen.',
      already_applied: 'Ändringen finns redan i vägen.',
      missing_reason: 'Ange en motivering för beslutet.',
    },
    report: {
      intro: 'De wild cards som handlingsvägen testades med: vad varje kort skulle ha gjort med vägen, och användarens beslut med motivering.',
      changedItems: 'Ändringar i vägen',
      revealedTitle: 'Antaganden som wild cardet "{{title}}" avslöjade',
      signalsTitle: 'Signaler att bevaka och kontrollpunkter',
    },
  },
};
